import axios, { AxiosInstance } from "axios";
import { Api } from "../generated/Api";
import { ResCallback } from "../models";
import { ErrorUtils } from "./";

const { apiBaseUri } = (window as { [key: string]: any })["AVIS-Config"];

export const apiConfig = {
  baseURL: apiBaseUri,
  withCredentials: true,
};
// axios api with generated models
export const api = new Api(apiConfig);
// regular axios api
export const axiosApi: AxiosInstance = axios.create(apiConfig);
// atsevišķa kļūdu apstrāde uz login - uz 400 atgriež ķlūdas paziņojumu par nepareizi ievadītu lietotjāvārdu vai paroli
export const authApi: AxiosInstance = axios.create(apiConfig);
// atsevišķa kļūdu apstrāde uz logout - nedrīkst izsaukt logout(), jo būs infinite loop
export const logoutApi: AxiosInstance = axios.create(apiConfig);

export const setupAuthErrorHandlerInterceptors = (res: ResCallback): number => {
  return authApi.interceptors.response.use(
    (response) => response,
    (error) => {
      throw ErrorUtils.handleAuthControllerResponse(error, res);
    },
  );
};

export const setupAxiosErrorHandlerInterceptors = (
  axiosInstance: AxiosInstance,
  res: ResCallback,
  logout?: () => void,
): number => {
  return axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      throw ErrorUtils.handleAxiosErrorResponse(error, res, logout);
    },
  );
};

export const extractFilenameFromResponse = (
  contentDisposition: string | null,
) => {
  if (!contentDisposition) {
    return null;
  }
  // Extract the filename from the content-disposition header
  const result = contentDisposition
    .split(";")
    .find((part: string) => part.trim().startsWith("filename="))
    ?.split("=")[1]
    ?.replace(/"/g, "");
  return result;
};
